import './AdministratorClientScreen.scss';
import React from 'react';
import { Grid, Box, Paper } from '@mui/material';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Map } from 'immutable';
import { getClientForManager } from 'src/module/admin/selector';
import { updateClient } from 'src/module/admin/action';
import ClientDetails from 'src/component/ClientDetails';
import UsersList from 'src/component/UsersList';
import { useTranslation } from 'src/i18n';

export default function AdministratorClientScreen (props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const clientId = props.match.params.client_id;
  const clientRaw: any = useSelector(getClientForManager(clientId));
  const client: any = clientRaw.toJS();

  const handleCellChange = (rec) => {
    dispatch(updateClient(client.id, Map(rec)));
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2} sx={{ p: 3 }}>
        <Grid item xs={12} >
          <ClientDetails client={client} handleCellChange={handleCellChange} />
        </Grid>
        <Grid item xs={12}>
          <Paper>
            <h2>{t('admin.users')}</h2>
            <UsersList client={clientRaw} showSupportUsers={true}/>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}


AdministratorClientScreen.propTypes = {
  match: PropTypes.object
};

AdministratorClientScreen.defaultProps = {};
